import React from 'react'

function NuestrosServicios() {
  return (
    <div className='w-full h-4/12 flex flex-col items-center '>
 
    <div className='w-11/12 h-full p-3 btw:p-10 bg-GrisClaro flex justify-center items-center '>
      <div className='w-full h-full flex flex-col justify-evenly items-center btw:flex-row'>
        <div className='w-11/12 btw:w-5/12 h-60 bg-Blanco flex justify-evenly items-center mb-5 btw:mb-0'>
          <p className='text-sm bxsm:text-base text-center p-5 italic xl:text-xl'>
          Nos dedicamos a la venta de tecnología de precisión de implementos enfocados en el ahorro sustentable de agroquímicos en pulverización y también en siembra en general.
          </p>
      </div>
          <div className='w-11/12 btw:w-5/12 h-60'>
          <img src='https://agroh.info/imagenes/extras/perfilEmpresa.png' alt='empresa.png' className='w-full h-full object-cover' />
         {/*<iframe className='w-full h-full' src="https://www.youtube.com/embed/226Wk18pO_k?si=h0LbMHcqm94yjMLS" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>*/}
      </div>
      </div>
    </div>
  </div>
  )
}

export default NuestrosServicios